import { Row, Col, Container, Button } from "react-bootstrap";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import Image from 'react-bootstrap/Image';
import Logo from "../img/common/alive-logo.svg";

export const LandingPage = () => {
    const { instance } = useMsal();
    const handleLoginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    return (
        <>
            <Container>
                <Row>
                    <Col sm={5} className="p-0 pt-5">
                        <Image src={Logo} roundedCircle width={108} height={154.48} className='p-0' />
                        <div className="covr_catch pt-5">
                            <div className="covr_catch_en">
                                <span>LEAD</span><br />
                                <span>YOURSELF,</span><br />
                                <span className="covr_catch_en_green">LEAD</span><br />
                                <span className="covr_catch_en_green">THE FUTURE</span><br />
                            </div>
                            <div className="covr_catch_jp">
                                <span>じぶんをリードする、</span><br />
                                <span>次代をリードする</span><br />
                            </div>
                        </div>
                    </Col>
                    <Col sm={7} className="d-flex flex-column align-items-center justify-content-center">
                        <Row className="pt-3">
                            <h1 className="covr_title covr_catch_en">ALIVE Platform</h1>
                        </Row>
                        <Row className="p-1">
                            <h4 className="covr_title covr_catch_jp">管理者用ページです。</h4>
                        </Row>
                        <Row className="pt-5">
                            <Button variant="dark" size="lg" className="covr_btn" onClick={handleLoginRedirect}>ログインする→</Button>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}